<template>
    <div>
        <div class="p-6 pb-4 flex justify-end">
            <whatsapp-users-export-button
                :has-users="hasUsers"
                :sort-column="sortColumn"
                :sort-direction="sortDirection"
            ></whatsapp-users-export-button>
        </div>
        
        <div class="p-0 border-t border-gray-300">
            <whatsapp-users-table
                :users="users"
                @sort-changed="handleSortChanged"
            ></whatsapp-users-table>
        </div>
    </div>
</template>

<script>
import WhatsappUsersTable from './whatsapp-users-table.vue';
import WhatsappUsersExportButton from './whatsapp-users-export-button.vue';

export default {
    name: 'WhatsappUsersIndex',

    components: {
        WhatsappUsersTable,
        WhatsappUsersExportButton,
    },

    props: {
        users: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            sortColumn: 'joined_whats_app_community_at',
            sortDirection: 'desc',
        };
    },

    computed: {
        hasUsers() {
            return this.users && this.users.length > 0;
        },
    },

    methods: {
        handleSortChanged(sortData) {
            this.sortColumn = sortData.column;
            this.sortDirection = sortData.direction;
        },
    },
};
</script>

